const imageBanner = (index) => ({
    imageBanner: null,
    bannerMedia: null,
    headerGroup: null,
    announcementBar: null,
    headerHeight: 0,
    template: null,
    init() {

        window.addEventListener("load", ()=>{
            this.template = document.querySelector("main").getAttribute("data-template")
            this.imageBanner = document.querySelectorAll(".image-banner__section")
            this.announcementBar = document.querySelector(".announcement-bar")
            this.headerGroup = document.querySelector(".header-group")

            if (this.headerGroup){
                if (this.announcementBar){
                    this.headerHeight = this.announcementBar.offsetHeight + this.headerGroup.offsetHeight
                }else{
                    this.headerHeight = this.headerGroup.offsetHeight
                }
            }
        })
    }
})

export default imageBanner

document.addEventListener("alpine:init", () => {
    Alpine.data("imageBanner", imageBanner);
})